import { Box, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { BlockWidget } from 'components';
import cx from 'clsx';
import { amountCell, controlCell, hiddenWhenStacked, textCell } from '../style.css';
import { wrappingHeading } from '../style.css';
import { fmt } from 'utilities';
import type { LinkerContext } from '../types';
import { ExpenseRowsPopover } from './ExpenseRowsPopover';
import { LinkableRowsPopover } from './LinkableRowsPopover';
import { centeredCell, clickable, numberCell, tableCell } from './style.css';
import type { ImportedBlockGroup } from './types';

interface RowProps {
  group: ImportedBlockGroup;
  linkerContext: LinkerContext;
}

/**
 * A single row in the ImportedBlocksLinker table - represents expense rows and linkable campaign block rows,
 * grouped under the same imported block code.
 */
export function Row({ group, linkerContext }: RowProps) {
  const showExpensePopover = group.expenseRows.length > 0;
  const showLinkablePopover = group.linkableRows.length > 0;

  return (
    <>
      <td className={cx(centeredCell, hiddenWhenStacked)} />
      <td className={cx(tableCell, textCell)}>
        {group.reason ? (
          <Box>
            {group.block ? <BlockWidget {...group.block} link flat className={wrappingHeading} /> : group.blockCode}
            <Box textSize="xs" className="text-danger">
              {group.reason}
            </Box>
          </Box>
        ) : group.block ? (
          <BlockWidget {...group.block} link flat className={wrappingHeading} />
        ) : (
          group.blockCode
        )}
      </td>
      <td className={cx(centeredCell, hiddenWhenStacked)} />
      <td className={cx(numberCell, amountCell)} data-label="Expense">
        {showExpensePopover ? (
          <PopoverRoot>
            <PopoverTrigger>
              <span role="button" className={clickable}>
                {fmt(group.expenseAmount)}
              </span>
            </PopoverTrigger>
            <PopoverPopup portal placement="auto" offsetOptions={0}>
              <ExpenseRowsPopover rows={group.expenseRows} />
            </PopoverPopup>
          </PopoverRoot>
        ) : (
          fmt(group.expenseAmount)
        )}
      </td>
      <td className={cx(numberCell, amountCell)} data-label="Balance">
        {showLinkablePopover ? (
          <PopoverRoot>
            <PopoverTrigger>
              <span role="button" className={clickable}>
                {fmt(group.linkableAmount)}
              </span>
            </PopoverTrigger>
            <PopoverPopup portal placement="auto" offsetOptions={6}>
              <LinkableRowsPopover linkableIds={group.linkableRows.map((r) => r.id)} linkerContext={linkerContext} />
            </PopoverPopup>
          </PopoverRoot>
        ) : (
          fmt(group.linkableAmount)
        )}
      </td>
      <td className={cx(centeredCell, controlCell)} />
    </>
  );
}
